import React, { useContext, useEffect, useState } from 'react';
import { Snackbar, Alert, Slide } from '@material-ui/core';
import { globalStateContext, globalDispatchContext } from 'store';
import { CONST } from 'reducers';

export default function Message(): JSX.Element {
  const { appMessage } = useContext(globalStateContext);
  const { dispatch } = useContext(globalDispatchContext);

  return (
    <>
      {appMessage && (
        <Snackbar
          style={{ minWidth: '20vw' }}
          TransitionComponent={(props) => (
            <Slide {...props} direction="right" />
          )}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          open={!!appMessage}
          autoHideDuration={6000}
          onClose={(e, reason) => {
            //TODO: for some reaosn onClose is always firing even it not present on page
            if (reason === 'clickaway') {
              return;
            }
            dispatch({ type: CONST.CLEAR_MESSAGE });
          }}
        >
          <Alert
            onClose={() => {
              dispatch({ type: CONST.CLEAR_MESSAGE });
            }}
            severity="info"
          >
            {appMessage}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}
